
import { toast } from 'react-toastify';
import { InputField, NXForm } from '../common';
import NxtbnModal from '../Modal';
import { useEffect, useState } from 'react';
import useApi from '../../api';

interface SupplierCreateProps {
    isOpen: boolean;
    onClose: ()=>void;
    edit?: any;
    refresh:()=>void;
}

function SupplierForm({isOpen, onClose, edit, refresh}:SupplierCreateProps) {
    const [formData, setFormData] = useState<any>();
    const [errorData, setErrorData] = useState<any>({});
  
    const api = useApi();

    useEffect(()=>{
      if (edit){
        setFormData(edit)
      }
    }, [edit])
  
    const handleSubmit = (e: React.FormEvent) => {
      e.preventDefault();
      if (edit) {
          api.updateSupplier(edit.id, formData).then((response: any) => {
            refresh()
            onClose();
            toast.success("Supplier Updated Successfully!");
          }, (error) => {
            toast.error("Supplier update is failed!")
          });
        
      } else {
          api.createSupplier(formData).then((response: any) => {
            refresh()
            toast.success("Supplier Created Successfully!");
            onClose();
          }, (error) => {
              setErrorData(error.response.data);
          });
      }
      
    };
  
    const handleChange = (e: any) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });
    };

  return (
    <NxtbnModal isOpen={isOpen} onClose={onClose}>
      <NXForm
        onSubmit={handleSubmit}
        className="p-6"
        title={edit ? `Edit Supplier: ${formData?.name || formData?.id}` : 'Add Supplier'}
        nonFieldError={{}}
      >
        <div className="mt-4">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700">
            Name
          </label>
          <InputField
            type="text"
            id="name"
            name='name'
            errorData={errorData}
            defaultValue={formData?.name}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          />
        </div>
        <div className="mt-4">
          <label htmlFor="description" className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <InputField
            type="text"
            id="description"
            name='description'
            errorData={errorData}
            defaultValue={formData?.description}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          />
        </div>
        <div className="mt-4">
          <label htmlFor="meta_title" className="block text-sm font-medium text-gray-700">
            Meta title
          </label>
          <InputField
            type="text"
            id="meta_title"
            name='meta_title'
            errorData={errorData}
            defaultValue={formData?.meta_title}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          />
        </div>
        <div className="mt-4">
          <label htmlFor="meta_description" className="block text-sm font-medium text-gray-700">
            Meta description
          </label>
          <InputField
            type="text"
            id="meta_description"
            name='meta_description'
            errorData={errorData}
            defaultValue={formData?.meta_description}
            onChange={handleChange}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          />
        </div>


        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="mr-3 inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-gray-600 text-base font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-primary-600 text-base font-medium text-white shadow-sm hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          >
            {edit ? 'Update' : 'Create'}
          </button>
        </div>
      </NXForm>
    </NxtbnModal>
  )
}

export default SupplierForm